(() => {
  const TIMER_KEY = 'custom_cart_reserved_until';
  const DEFAULT_DURATION = 300;
  let timerId = null;
  let observer = null;

  const selectors = {
    drawer: '[data-custom-cart-drawer], cart-drawer',
    reserved: '[data-custom-cart-reserved], [data-tr-cart-reserved]',
    timer: '[data-custom-cart-timer], [data-tr-timer]',
    item: '[data-custom-cart-item], .custom-cart-item, .cart-item',
    empty: '.drawer__inner-empty',
    drawerItems: 'cart-drawer-items',
    inner: '.drawer__inner'
  };

  const formatTime = (seconds) => {
    const min = String(Math.floor(seconds / 60)).padStart(2, '0');
    const sec = String(seconds % 60).padStart(2, '0');
    return `${min}:${sec}`;
  };

  const getReservedUntil = (duration, reset = false) => {
    const now = Math.floor(Date.now() / 1000);
    let until = Number(localStorage.getItem(TIMER_KEY) || 0);

    if (reset || !until || until <= now) {
      until = now + duration;
      localStorage.setItem(TIMER_KEY, String(until));
    }

    return until;
  };

  const getReservedBars = (root = document) => {
    if (root.nodeType === 1 && root.matches?.(selectors.reserved)) {
      return [root];
    }

    return Array.from(root.querySelectorAll?.(selectors.reserved) || []);
  };

  const initReservedTimer = (root = document, reset = false) => {
    const bars = getReservedBars(root);
    if (!bars.length) return;

    const bar = bars[0];
    const output = bar.querySelector(selectors.timer);
    const duration = Number(bar.dataset.duration || DEFAULT_DURATION);
    const until = getReservedUntil(duration, reset);

    bar.hidden = false;
    bar.removeAttribute('hidden');
    bar.style.removeProperty('display');

    if (timerId) {
      clearTimeout(timerId);
    }

    const tick = () => {
      const now = Math.floor(Date.now() / 1000);
      const left = Math.max(0, until - now);

      if (output) {
        output.textContent = formatTime(left);
      }

      if (left > 0) {
        timerId = setTimeout(tick, 250);
      }
    };

    tick();
  };

  const hasCartItems = (drawer) => {
    if (!drawer) return false;

    return Array.from(drawer.querySelectorAll(selectors.item)).some((item) => {
      return !item.closest('.drawer__inner-empty');
    });
  };

  const normalizeDrawerState = () => {
    const drawer = document.querySelector(selectors.drawer);
    if (!drawer || !hasCartItems(drawer)) return;

    drawer.classList.remove('is-empty', 'custom-cart-drawer--empty');
    drawer.removeAttribute('data-empty');

    drawer.querySelectorAll(`${selectors.drawerItems}, ${selectors.inner}`).forEach((node) => {
      node.classList.remove('is-empty');
      node.removeAttribute('data-empty');
      node.removeAttribute('hidden');
      node.removeAttribute('inert');
    });

    drawer.querySelectorAll(selectors.empty).forEach((node) => {
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
    });
  };

  const init = (root = document, resetTimer = false) => {
    initReservedTimer(root, resetTimer);
    normalizeDrawerState();
  };

  const startObserver = () => {
    if (observer || !window.MutationObserver) return;

    observer = new MutationObserver((mutations) => {
      let shouldInit = false;
      let shouldResetTimer = false;

      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;

          const hasReserved = node.matches?.(selectors.reserved) || node.querySelector?.(selectors.reserved);
          const hasItem = node.matches?.(selectors.item) || node.querySelector?.(selectors.item);

          if (hasReserved) {
            shouldInit = true;
            shouldResetTimer = true;
            break;
          }

          if (hasItem) {
            shouldInit = true;
            break;
          }
        }

        if (shouldInit) break;
      }

      if (shouldInit) {
        init(document, shouldResetTimer);
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    init(document, false);
    startObserver();
  });

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target || document, false);
  });

  document.addEventListener('cart:updated', () => {
    init(document, true);
  });

  document.addEventListener('custom:cart-drawer:refresh', () => {
    init(document, true);
  });

  window.customCartDrawer = window.customCartDrawer || {};
  window.customCartDrawer.init = init;
  window.customCartDrawer.normalize = normalizeDrawerState;
})();